const handleTime = (value, noPad) => (!noPad && value < 10 && value != 0) ? '0' + value : value;

const parseHours = (value, noPad) => {
    let parsedValue = parseFloat(value);
    if(!parsedValue && parsedValue !== 0)
        return 0;
    return handleTime(Math.floor(parsedValue / 3600), noPad);
}
const parseMinutes = (value, noPad) => {
    let parsedValue = parseFloat(value);
    if(!parsedValue && parsedValue !== 0)
        return 0;
    return handleTime(Math.floor((value % 3600) / 60), noPad);
}
const parseSeconds = (value, noPad) => {
    let parsedValue = parseFloat(value);
    if(!parsedValue && parsedValue !== 0)
        return 0;
    return handleTime(Math.floor((value % 3600) % 60), noPad);
}

export {
    parseHours,
    parseMinutes,
    parseSeconds
}